"use client";

import React from "react";
import Image from "next/image";
import type { LandingPopular, PopularProduct } from "./types";

const PopularProductCard: React.FC<{ item: PopularProduct }> = ({ item }) => {
	return (
		<div className="relative flex flex-col rounded-[6px] bg-white border border-[var(--automint-onboarding-dotted-line)] overflow-hidden min-w-[60%] flex-shrink-0 snap-start md:min-w-0 md:flex-shrink">
			{item.featured && (
				<div className="absolute top-2 right-2 md:top-2 md:right-2 z-10">
					<Image
						src="/new_icons/buyback/assured-buyback-icon.svg"
						alt="Assured buy back"
						width={20}
						height={20}
						className="md:!w-6 md:!h-6"
					/>
				</div>
			)}
			<div
				className={`pt-3 pb-1 text-center min-h-[52px] md:min-h-0 flex flex-col justify-center md:block md:!px-3 ${item.featured ? "px-8" : "px-3"}`}
			>
				<p className="text-sm md:text-xs font-medium text-automint-black leading-tight">
					{item.name}
				</p>
				<p className="text-xs md:text-xs text-second mt-0.5 leading-tight">
					{item.variant}
				</p>
			</div>
			<div className="relative h-[110px] md:h-[80px] 2xl:h-[100px] w-full my-1">
				<Image
					src={item.image}
					alt={item.imageAlt}
					fill
					sizes="(min-width: 768px) 200px, 60vw"
					className="object-contain"
				/>
			</div>
			<div className="px-2 py-2 text-center min-h-[48px] md:min-h-[48px] flex flex-col items-center justify-center">
				<p className="text-sm md:text-sm font-semibold text-[var(--automint-success-text-light)] leading-tight">
					{item.highlight}
				</p>
				{item.subtext && (
					<p className="text-[10px] md:text-[10px] font-medium text-second tracking-wide leading-tight mt-1">
						{item.subtext}
					</p>
				)}
			</div>
		</div>
	);
};

interface PopularProductsProps {
	data: LandingPopular;
}

export const PopularProducts: React.FC<PopularProductsProps> = ({ data }) => {
	return (
		<div className="w-full">
			<p className="text-lg md:text-xl font-light text-automint-black mb-3">
				{data.title}
			</p>
			<div className="flex gap-3 overflow-x-auto snap-x snap-mandatory hide-scrollbar md:grid md:grid-cols-3 md:gap-4 md:overflow-visible md:snap-none">
				{data.items.map((item) => (
					<PopularProductCard key={item.id} item={item} />
				))}
			</div>
		</div>
	);
};
